import WebskyServicesAnalytics from '../WebskyServicesAnalytics';
import Base from './Base';
class Aeroexpress extends Base {
    constructor(orderBeforeChange, orderAfterChange) {
        super(orderBeforeChange, orderAfterChange);
    }
    diff() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const added = [];
        const removed = [];
        const { added: aeroexpressAdded, removed: aeroexpressRemoved } = this.getTravellersServicesDiff((_d = (_c = (_b = (_a = this.orderBeforeChange) === null || _a === void 0 ? void 0 : _a.additionalServices) === null || _b === void 0 ? void 0 : _b.transfer) === null || _c === void 0 ? void 0 : _c.aeroexpress) === null || _d === void 0 ? void 0 : _d.selectedTrips, (_h = (_g = (_f = (_e = this.orderAfterChange) === null || _e === void 0 ? void 0 : _e.additionalServices) === null || _f === void 0 ? void 0 : _f.transfer) === null || _g === void 0 ? void 0 : _g.aeroexpress) === null || _h === void 0 ? void 0 : _h.selectedTrips, service => service.id);
        added.push(...WebskyServicesAnalytics.aeroexpress(aeroexpressAdded, (_k = (_j = this.orderAfterChange) === null || _j === void 0 ? void 0 : _j.travellers) !== null && _k !== void 0 ? _k : []));
        removed.push(...WebskyServicesAnalytics.aeroexpress(aeroexpressRemoved, (_m = (_l = this.orderAfterChange) === null || _l === void 0 ? void 0 : _l.travellers) !== null && _m !== void 0 ? _m : []));
        return { added, removed };
    }
}
export default Aeroexpress;
